import { render, staticRenderFns } from "./Vpt.vue?vue&type=template&id=390926a8&scoped=true&"
import script from "./Vpt.vue?vue&type=script&lang=js&"
export * from "./Vpt.vue?vue&type=script&lang=js&"
import style0 from "./Vpt.vue?vue&type=style&index=0&id=390926a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390926a8",
  null
  
)

/* custom blocks */
import block0 from "./Vpt.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports